module.exports = __webpack_public_path__ + "img/Gruppenführer_WP.6a517a20.svg";